const CACHE_TIME = 1000 * 60 * 5;
class Cache {
    constructor() {
        this.promises = {};
    }
    delete(key) {
        Object.keys(this.promises)
            .filter((url) => url.startsWith(key))
            .forEach((url) => delete this.promises[url]);
    }
    clear() {
        this.promises = {};
    }
    get(key) {
        if (this.promises[key] &&
            this.promises[key].timeout > new Date().getTime()) {
            return this.promises[key].promise;
        }
        else {
            this.delete(key);
            return;
        }
    }
    set(key, promise) {
        this.promises[key] = {
            promise,
            timeout: new Date().getTime() + CACHE_TIME,
        };
        return promise;
    }
}
export const cache = new Cache();
